import React from 'react';
import StepSettingSiteSearch from './content/stepConfirmSiteSearch';
import PropTypes from 'prop-types';

const propTypes = {
    updateKeyWord: PropTypes.func,
    search: PropTypes.func,
    closeModal: PropTypes.func
};

class Main extends React.Component {

    render() {

        let content = []
        let sub_title = this.props.contenttitle[this.props.step]

        //StepSettingSiteSearchのメインコンテンツを読み込む
        if(this.props.step == 1){
            content.push(
                <StepSettingSiteSearch 
                    searchdomain={this.props.searchdomain}
                    searchResultList={this.props.searchResultList}
                    searchResulSelectBox={this.props.searchResulSelectBox}
                    pagenum={this.props.pagenum}
                    totalnum={this.props.totalnum}
                    currentPage={this.props.currentPage}
                    isDispModal={this.props.isDispModal}
                    isDispSearchList={this.props.isDispSearchList}
                    isURLDisp={this.props.isURLDisp}
                    isSelectBoxChange={this.props.isSelectBoxChange}
                    modalErrorMessage={this.props.modalErrorMessage}
                    search={(pageid) => { this.props.search(pageid); }}
                    updateDispType={(value) => { this.props.updateDispType(value); }}
                    updateSelectBox={(name,value) => { this.props.updateSelectBox(name,value); }}
                    updateIsDispModal={(errorMessage) => { this.props.updateIsDispModal(errorMessage); }}
                    closeModal={() => { this.props.closeModal(); }}                   
                />
            );
        }

        return (
            <main id="contents" className="main-setting">
                <section className="section">
                    <h2 id="sub_title">{sub_title}</h2>
                    {content}
                </section>
            </main>
        );
    }
}

export default Main;

